import StockTakeDetails from "./stockTakeDetails.container"

export default StockTakeDetails
